import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { getUserRole } from '../../../helpers/AxiosAPI';

import defaultDash from './default';
import analyticsDash from './analytics';

const Dashboards = ({ match }) => (
    <div className="dashboard-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/analytics`} />
            <Route path={`${match.url}/default`} component={defaultDash} />
            {getUserRole() !== "Agent" ?
                <Route path={`${match.url}/analytics`} component={analyticsDash} />
                : <Redirect to="/access-denied" />
            }
            <Redirect to="/error" />
        </Switch>
    </div>
);
export default Dashboards;